import { Types, types } from '../types'

const initialState = {
    waiting: false,
    success: false,
    error: '',

}

const lineSettingsReducer = (state = initialState, { type, action, params }) => {
    switch (type) {


        case types.GET_GENERAL_LINE_SETTINGS_REQUEST: {

            return {
                ...state,
                getGeneralSettingsWaiting: true,
                getGeneralSettingsSuccess: false,
                getGeneralSettingsError: '',
                generalSettings: undefined

            }
        }

        case types.GET_GENERAL_LINE_SETTINGS_SUCCESS: {
            return {
                ...state,
                getGeneralSettingsWaiting: false,
                getGeneralSettingsSuccess: true,
                generalSettings: action.data
            }
        }

        case types.GET_GENERAL_LINE_SETTINGS_ERROR: {

            return {
                ...state,
                getGeneralSettingsWaiting: false,
                getGeneralSettingsError: '',
            }
        }

        case types.SET_GENERAL_LINE_SETTINGS_REQUEST: {

            return {
                ...state,
                setGeneralSettingsWaiting: true,
                setGeneralSettingsSuccess: false,
                setGeneralSettingsError: '',

            }
        }

        case types.SET_GENERAL_LINE_SETTINGS_SUCCESS: {
            return {
                ...state,
                setGeneralSettingsWaiting: false,
                setGeneralSettingsSuccess: true,
            }
        }

        case types.SET_GENERAL_LINE_SETTINGS_ERROR: {

            return {
                ...state,
                setGeneralSettingsWaiting: false,
                setGeneralSettingsError: '',
            }
        }


        case types.GET_CUSTOMER_LINE_SERVICES_REQUEST: {

            return {
                ...state,
                getCustomerLineServicesWaiting: true,
                getCustomerLineServicesSuccess: false,
                getCustomerLineServicesError: '',

            }
        }

        case types.GET_CUSTOMER_LINE_SERVICES_SUCCESS: {
            return {
                ...state,
                getCustomerLineServicesWaiting: false,
                getCustomerLineServicesSuccess: true,
                customerLineServices: action.data
            }
        }

        case types.GET_CUSTOMER_LINE_SERVICES_ERROR: {

            return {
                ...state,
                getCustomerLineServicesWaiting: false,
                getCustomerLineServicesError: '',
            }
        }


        case types.GET_CALL_REPORT_SETTINGS_REQUEST: {

            return {
                ...state,
                getCallReportSettingsWaiting: true,
                getCallReportSettingsSuccess: false,
                getCallReportSettingsError: '',

            }
        }

        case types.GET_CALL_REPORT_SETTINGS_SUCCESS: {
            return {
                ...state,
                getCallReportSettingsWaiting: false,
                getCallReportSettingsSuccess: true,
                callReportSettings: action.data
            }
        }

        case types.GET_CALL_REPORT_SETTINGS_ERROR: {

            return {
                ...state,
                getCallReportSettingsWaiting: false,
                getCallReportSettingsError: '',
            }
        }

        case types.SET_CALL_REPORT_SETTINGS_REQUEST: {

            return {
                ...state,
                saveCallReportSettingsWaiting: true,
                saveCallReportSettingsSuccess: false,
                saveCallReportSettingsError: '',

            }
        }

        case types.SET_CALL_REPORT_SETTINGS_SUCCESS: {
            return {
                ...state,
                saveCallReportSettingsWaiting: false,
                saveCallReportSettingsSuccess: true,
            }
        }

        case types.SET_CALL_REPORT_SETTINGS_ERROR: {

            return {
                ...state,
                saveCallReportSettingsWaiting: false,
                saveCallReportSettingsError: '',
            }
        }


        case types.GET_LINE_FAX_SETTINGS_REQUEST: {

            return {
                ...state,
                getLineFaxSettingsWaiting: true,
                getLineFaxSettingsSuccess: false,
                getLineFaxSettingsError: '',

            }
        }

        case types.GET_LINE_FAX_SETTINGS_SUCCESS: {

            return {
                ...state,
                getLineFaxSettingsWaiting: false,
                getLineFaxSettingsSuccess: true,
                lineFaxSettings: action.data
            }
        }

        case types.GET_LINE_FAX_SETTINGS_ERROR: {

            return {
                ...state,
                getLineFaxSettingsWaiting: false,
                getLineFaxSettingsError: '',
            }
        }

        case types.SET_LINE_FAX_SETTINGS_REQUEST: {

            return {
                ...state,
                saveLineFaxSettingsWaiting: true,
                saveLineFaxSettingsSuccess: false,
                saveLineFaxSettingsError: '',

            }
        }

        case types.SET_LINE_FAX_SETTINGS_SUCCESS: {
            return {
                ...state,
                saveLineFaxSettingsWaiting: false,
                saveLineFaxSettingsSuccess: true,
            }
        }

        case types.SET_LINE_FAX_SETTINGS_ERROR: {

            return {
                ...state,
                saveLineFaxSettingsWaiting: false,
                saveLineFaxSettingsError: '',
            }
        }


        case types.GET_LINE_VOICEMAIL_SETTINGS_REQUEST: {

            return {
                ...state,
                getLineVoicemailWaiting: true,
                getLineVoicemailSuccess: false,
                getLineVoicemailError: '',

            }
        }

        case types.GET_LINE_VOICEMAIL_SETTINGS_SUCCESS: {

            return {
                ...state,
                lineVoicemailSettings: action.data,

                getLineVoicemailWaiting: false,
                getLineVoicemailSuccess: true,
            }
        }

        case types.GET_LINE_VOICEMAIL_SETTINGS_ERROR: {

            return {
                ...state,
                getLineVoicemailWaiting: false,
                getLineVoicemailError: '',
            }
        }


        case types.SET_LINE_VOICEMAIL_SETTINGS_REQUEST: {

            return {
                ...state,
                saveLineVoicemailWaiting: true,
                saveLineVoicemailSuccess: false,
                saveLineVoicemailError: '',

            }
        }

        case types.SET_LINE_VOICEMAIL_SETTINGS_SUCCESS: {
            return {
                ...state,
                saveLineVoicemailWaiting: false,
                saveLineVoicemailSuccess: true,
            }
        }

        case types.SET_LINE_VOICEMAIL_SETTINGS_ERROR: {

            return {
                ...state,
                saveLineVoicemailWaiting: false,
                saveLineVoicemailError: '',
            }
        }

        case types.GET_CUSTOMER_MEMBERS_REQUEST: {

            return {
                ...state,
                getCustomerMembersWaiting: true,
                getCustomerMembersSuccess: false,
                getCustomerMembersError: '',
                customerMembers: {}

            }
        }

        case types.GET_CUSTOMER_MEMBERS_SUCCESS: {
            return {
                ...state,
                getCustomerMembersWaiting: false,
                getCustomerMembersSuccess: true,
                getCustomerMembersError: '',
                customerMembers: action.data
            }
        }

        case types.GET_CUSTOMER_MEMBERS_ERROR: {

            return {
                ...state,
                getCustomerMembersWaiting: false,
                getCustomerMembersSuccess: false,
                getCustomerMembersError: 'error',
                customerMembers: action?.data
            }
        }

        case types.RESET_GET_CUSTOMER_MEMBERS_ERROR: {
            return {
                ...state,
                getCustomerMembersWaiting: false,
                getCustomerMembersSuccess: false,
                getCustomerMembersError: '',
                customerMembers: {}
            }
        }

        case types.SET_SELECTED_COUSTOMER: {
            return {
                ...state,
                customerSelected: params
            }
        }

        case types.RESET_SELECTED_CUSTOMER: {
            return {
                ...state,
                customerSelected: ''
            }
        }

        case types.SET_SELECTED_IVR: {

            return {
                ...state,
                ivrSelected: params
            }
        }

        case types.RESET_SELECTED_IVR: {
            return {
                ...state,
                ivrSelected: ''
            }
        }


        case types.GET_PASSWORD_STATUS_REQUEST: {

            return {
                ...state,
                getPasswordStatusWaiting: true,
                getPasswordStatusSuccess: false,
                getPasswordStatusError: '',

            }
        }

        case types.GET_PASSWORD_STATUS_SUCCESS: {
            return {
                ...state,
                getPasswordStatusWaiting: false,
                getPasswordStatusSuccess: true,
                passwordSettingStatus: action.data
            }
        }

        case types.GET_PASSWORD_STATUS_ERROR: {

            return {
                ...state,
                getPasswordStatusWaiting: false,
                getPasswordStatusError: '',
            }
        }

        case types.SET_PASSWORD_STATUS_REQUEST: {

            return {
                ...state,
                setPasswordStatusWaiting: true,
                setPasswordStatusSuccess: false,
                setPasswordStatusError: '',

            }
        }

        case types.SET_PASSWORD_STATUS_SUCCESS: {
            return {
                ...state,
                setPasswordStatusWaiting: false,
                setPasswordStatusSuccess: true,
            }
        }

        case types.SET_PASSWORD_STATUS_ERROR: {

            return {
                ...state,
                setPasswordStatusWaiting: false,
                setPasswordStatusError: '',
            }
        }


        case types.SET_PASSWORD_SETTING_REQUEST: {

            return {
                ...state,
                setPasswordSettingWaiting: true,
                setPasswordSettingSuccess: false,
                setPasswordSettingError: '',

            }
        }

        case types.SET_PASSWORD_SETTING_SUCCESS: {
            return {
                ...state,
                setPasswordSettingWaiting: false,
                setPasswordSettingSuccess: true,
            }
        }

        case types.SET_PASSWORD_SETTING_ERROR: {

            return {
                ...state,
                setPasswordSettingWaiting: false,
                setPasswordSettingError: '',
            }
        }



        case types.GET_LINE_SEPARATION_SETTING_REQUEST: {

            return {
                ...state,
                getLineSeparationSettingWaiting: true,
                getLineSeparationSettingSuccess: false,
                getLineSeparationSettingError: '',

            }
        }

        case types.GET_LINE_SEPARATION_SETTING_SUCCESS: {
            return {
                ...state,
                getLineSeparationSettingWaiting: false,
                getLineSeparationSettingSuccess: true,
                lineSeparationSettings: action.data
            }
        }

        case types.GET_LINE_SEPARATION_SETTING_ERROR: {

            return {
                ...state,
                getLineSeparationSettingWaiting: false,
                getLineSeparationSettingError: '',
            }
        }



        case types.POST_UPLOAD_MUSIC_ON_HOLD_REQUEST: {

            return {
                ...state,
                uploadMusicOnHoldWaiting: true,
                uploadMusicOnHoldSuccess: false,
                uploadMusicOnHoldError: '',
                uploadMusicOnHoldResult: null
            }
        }



        case types.POST_UPLOAD_MUSIC_ON_HOLD_SUCCESS: {
            return {
                ...state,
                uploadMusicOnHoldWaiting: false,
                uploadMusicOnHoldSuccess: true,
                uploadMusicOnHoldResult: action.data
            }
        }

        case types.POST_UPLOAD_MUSIC_ON_HOLD_ERROR: {

            return {
                ...state,
                uploadMusicOnHoldWaiting: false,
                uploadMusicOnHoldError: '',
            }
        }


        case types.RESET_VOICE_MAIL_LINE_SETTINGS: {
            return {
                ...state,
                uploadMusicOnHoldResult: null,
                lineVoicemailSettings: null
            }
        }



        case types.LINE_SETTINGS_RESET_PROPS: {
            return {
                ...state,
                getGeneralSettingsWaiting: false,
                getGeneralSettingsSuccess: false,
                getGeneralSettingsError: '',
                getCustomerLineServicesWaiting: false,
                getCustomerLineServicesSuccess: false,
                getCustomerLineServicesError: '',
                getCallReportSettingsWaiting: false,
                getCallReportSettingsSuccess: false,
                getCallReportSettingsError: '',
                getLineVoicemailWaiting: false,
                getLineVoicemailSuccess: false,
                getLineVoicemailError: '',
                getLineFaxSettingsWaiting: false,
                getLineFaxSettingsSuccess: false,
                getLineFaxSettingsError: '',
                getCustomerMembersWaiting: false,
                getCustomerMembersSuccess: false,
                getCustomerMembersError: '',
                getPasswordStatusWaiting: false,
                getPasswordStatusSuccess: false,
                getPasswordStatusError: '',
                setGeneralSettingsWaiting: false,
                setGeneralSettingsSuccess: false,
                setGeneralSettingsError: '',
                saveCallReportSettingsWaiting: false,
                saveCallReportSettingsSuccess: false,
                saveCallReportSettingsError: '',
                saveLineFaxSettingsWaiting: false,
                saveLineFaxSettingsSuccess: false,
                saveLineFaxSettingsError: '',


            }
        }
        default:
            return state
    }
}

export default lineSettingsReducer;